import request from '@/utils/request';
/* 列表 */
export function goodsTagList(data) {
  return request({
    url: '/goods/label/queryGoodsLabelPageList',
    method: 'POST',
    data
  });
}
/* 增加 */
export function goodsTagAdd(data) {
  return request({
    url: '/goods/label/saveGoodsLabel',
    method: 'POST',
    data
  });
}
/* 修改 */
export function goodsTagEdit(data) {
  return request({
    url: '/goods/label/updateGoodsLabel',
    method: 'POST',
    data
  });
}
/* 修改中的信息展示 */
export function goodsTagInfo(data) {
  return request({
    url: '/goods/label/fetchGoodsLabelDetailById',
    method: 'POST',
    data
  });
}
/* 删除 */
export function goodsTagDel(data) {
  return request({
    url: '/goods/label/removeGoodsLabelById',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/goodsTag.js